export interface IPricePerNightRate {
  tax_is_included: boolean;
  rate_plan: string;
  nights: number;
  rent_price_per_night: number;
  rent_price_total: number;
  is_refundable: boolean;
}

export default class PricePerNightRate {
  taxIsIncluded: boolean;
  ratePlan: string;
  nights: number;
  pricePerNight: number;
  totalPrice: number;
  isRefundable: boolean;

  constructor(data: IPricePerNightRate) {
    this.taxIsIncluded = data.tax_is_included;
    this.ratePlan = data.rate_plan;
    this.nights = data.nights;
    this.pricePerNight = data.rent_price_per_night;
    this.totalPrice = data.rent_price_total;
    this.isRefundable = data.is_refundable;
  }

  toJson(): Record<string, unknown> {
    const json: Record<string, unknown> = {};
    if (this.taxIsIncluded !== null) json.tax_is_included = this.taxIsIncluded;
    if (this.ratePlan !== null) json.rate_plan = this.ratePlan;
    if (this.nights !== null) json.nights = this.nights;
    if (this.pricePerNight !== null) json.price_per_night = this.pricePerNight;
    if (this.totalPrice !== null) json.total_price = this.totalPrice;
    if (this.isRefundable !== null) json.is_refundable = this.isRefundable;

    return json;
  }
}
